export const BUILD_URL = 'BUILD_URL';
